import ServiceEndpoints from "./ServiceEndpoints";

export interface ServiceVersionInfo {
  version: string;
  buildDate: string;
  status: string;
}

export interface CacheStoreInfo {
  [key: string]: string | null;
}

export interface VersionInfo {
  core: {
    appVersion: string;
    appBuildDate: string;
    status: string;
  };
  docGenerator: ServiceVersionInfo;
  admin: ServiceVersionInfo;
  importer: ServiceVersionInfo;
  cacheStore: CacheStoreInfo;
}

export interface VersionInfoResponse {
  data?: VersionInfo;
  error?: string;
  status?: number;
}

export async function fetchVersionInfo(userToken?: string): Promise<VersionInfoResponse> {
  const endpoint = ServiceEndpoints.FetchVersionInfo;
  const headers: HeadersInit = { "Content-Type": "application/json" };

  if (userToken) {
    headers["Authorization"] = "Bearer " + userToken;
  }

  return await fetch(endpoint, {
    method: 'get',
    headers: headers,
  })
    .then(async (resp) => {
      if (resp.ok) {
        const parsedData: VersionInfo = await resp.json();
        return { data: parsedData };
      } else {
        console.error("Failed to fetch version info:", resp.status, resp.statusText);
        if (resp.status === 401) {
          return { error: "Unauthorized: Please log in again to access version information", status: 401 };
        }
        return { error: `Failed to fetch version info: ${resp.statusText}`, status: resp.status };
      }
    })
    .catch((error) => {
      console.error("Error fetching version info:", error);
      return { error: "An error occurred while fetching version information" };
    });
}
